import React, { Component } from 'react';
import { Modal, Row, Col, Spin, InputNumber, Select, message, Tooltip } from 'antd';
import SearchInput from '../../../common/SearchInput';
import Text from '../../../basicElement/Text';
import VisitWindow from './VisitWindow';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';
import genConfig from '../../../shared/genConfig';
import { getMatchOption, generateOptions } from '../../../shared/selectFn';
import { DateType, SymbolType, VisitTypeTimeUnit, HourType } from '../constants';

const width = 200;
const { Option } = Select;
const toString = value => value ? String(value) : undefined;
const hasValue = value => (value || value === 0) ? true : false;
const DateTypeOption = generateOptions(DateType);
const HourTypeOption = generateOptions(HourType);
const VisitTypeTimeUnitOption = generateOptions(VisitTypeTimeUnit);
const typeInConfig = {
    add: {
        title: '添加访视',
        url: API_URL.plan.addVisitType,
    },
    edit: {
        title: '修改访视',
        url: API_URL.plan.updateVisitType,
    }
};
const Enums = ['first', 'second', 'third'];
const DefaultData = {
    visitTypeTimeUnit: 'DAY',
    visitTypeWindowDateType: 'DAY',
    firstWindowSymbol: 'floor',
    secondWindowSymbol: 'ceil',
};

const getVisitWindowValue = (value, tier, params) => {
    if (value >= 0) {
        params[`${Enums[tier]}WindowSymbol`] = 'ceil';
        params[`${Enums[tier]}WindowValue`] = value;
    } else {
        params[`${Enums[tier]}WindowSymbol`] = 'floor';
        params[`${Enums[tier]}WindowValue`] = Math.abs(value);
    }
};

class Update extends Component {
    state = {
        visible: false,
        data: {},
        stageList: [],
        categoryList: [],
        visitingTypeList: [],
        visitTypeList: [],
        compareBasicList: [],
        visitCountOption: [],
        visitCommentOption: [],
        visitStage: '',
        visitType: {},
        loading: false,
    }

    config = {}

    show = (record, type) => {
        this.config = genConfig(typeInConfig, type);
        this.setState({
            visible: true,
            data: this.adaptData(record),
        }, () => {
            if (this.props.isBoundBlind) {
                this.queryVisit();
            }
            this.queryStage();
            this.queryCompareBasic();
            this.queryCategory();       // 访视类别
            if (this.config.edit) {
                this.queryType(record.visitCategory);   // 修改时按已有访视类别查询访视类型
            }
            this.querySingleVisitHourForAddVisit(record.visitingTypeId);
        });
    }

    adaptData = (record) => {
        let data;
        if (this.config.add) {
            return data = { ...DefaultData };
        } else {
            const {
                visitTypeId, visitStageId, visitPeriodId, visitingTypeId, visitingTypeShow, visitTypeName, referenceVisitTypeId,
                relatedId, visitTypeWindow, visitTypeWindowDateType, visitTypeWindowFloor, visitTypeWindowCeil,
                visitTypeTimeUnit,
                singleVisitHour,
                visitCategory,
                visitComment,
            } = record;
            data = {
                ...DefaultData,
                visitTypeId,
                visitStageId,
                visitPeriodId,
                visitingTypeId,
                visitingTypeShow,
                visitCategory,
                visitTypeName,
                visitComment,
                referenceVisitTypeId,
                relatedId,
                visitTypeWindow,
                singleVisitHour,
            };
            if (visitTypeWindowDateType) {
                data.visitTypeWindowDateType = visitTypeWindowDateType;
            }
            if (visitTypeTimeUnit) {
                data.visitTypeWindowDateType = visitTypeTimeUnit == 'DAY' ? (visitTypeWindowDateType || 'DAY') : (visitTypeWindowDateType || 'HOUR');
                data.visitTypeTimeUnit = visitTypeTimeUnit;
            }
            if (visitTypeWindowFloor || visitTypeWindowFloor === 0) {
                getVisitWindowValue(visitTypeWindowFloor, 0, data);
                getVisitWindowValue(visitTypeWindowCeil, 1, data);
            }
            return data;
        }
    }

    hide = () => {
        this.setState({
            visible: false,
            visitingTypeList: [],
            visitCountOption: [],
            visitCommentOption: [],
        });
    }

    // 单访视工时查询
    querySingleVisitHourForAddVisit = (visitingTypeId) => {
        if (!visitingTypeId) {
            return
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.querySingleVisitHourForAddVisit,
            data: { visitingTypeId },
            dataType: 'json',
            doneResult: res => {
                const { data } = this.state;
                if (!data.singleVisitHour) {
                    data.singleVisitHour = res.data;
                }
                this.setState({ data });
            },
        });
    }

    // 查询访视阶段
    queryStage = () => {
        const { visitGroupingId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryVisitStageByInvestigationId,
            data: { visitGroupingId },
            dataType: 'json',
            doneResult: res => {
                this.setState({ stageList: res.visitStageList });
            },
        });
    }
    
    // 查询访视类别
    queryCategory = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryCategoryForAddInvVisit,
            data: { limit: 99999 },
            dataType: 'json',
            doneResult: res => {
                this.setState({ categoryList: res.datas });
            },
        });
    }

    // 查询访视类型（依赖访视类别联动查询）
    queryType = (visitCategory) => {
        if (!visitCategory) {
            return
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.queryVisitingForAddInvVisit,
            data: { visitCategory },
            dataType: 'json',
            doneResult: res => {
                this.setState({ visitingTypeList: res.datas });
            },
        });
    }

    // 查询对照基准
    queryCompareBasic = () => {
        const { visitGroupingId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.visitTypeDataList,
            data: {
                visitGroupingId,
                publishStatus: 'ALL',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ compareBasicList: res.data.visitTypeList });
            },
        });
    }

    // 查询关联对应盲态项目访视次数
    queryVisit = () => {
        const { refGroupId } = this.props;
        $.sendRequest({
            method: 'POST',
            url: API_URL.plan.visitTypeDataList,
            data: {
                visitGroupingId: refGroupId,
                publishStatus: 'ALL',
            },
            dataType: 'json',
            doneResult: res => {
                this.setState({ visitTypeList: res.data.visitTypeList || [] });
            }
        });
    }

    handleChange = (value, key) => {
        const { data, visitingTypeList } = this.state;
        switch (key) {
            case 'visitStageId': {
                data.visitStageId = value;
                data.visitPeriodId = undefined;
                break;
            }
            case 'visitCategory': {
                data.visitCategory = value;
                data.visitingTypeId = undefined;
                break;
            }
            case 'visitingTypeId': {
                data.visitingTypeId = value;
                data.singleVisitHour = undefined;
                // 访视类型联动 带出访视备注
                const [matched] = (visitingTypeList || []).filter(el => el.visitingTypeId == value);
                data.visitComment = value && matched ? matched.regularRemark : undefined;
                break;
            }
            case 'visitTypeTimeUnit': {
                data.visitTypeTimeUnit = value;
                if(value == 'HOUR'){
                    data.visitTypeWindow = data.visitTypeWindow ? Math.floor(data.visitTypeWindow * (data.visitTypeWindowDateType == 'DAY' ? 24 : data.visitTypeWindowDateType == 'WEEK' ? 24 *7 : data.visitTypeWindowDateType == 'MONTH' ? 24 * 30 : 1)): undefined;
                    data.firstWindowValue = data.firstWindowValue ? Math.floor(data.firstWindowValue * 24) : undefined;
                    data.secondWindowValue = data.secondWindowValue ? Math.floor(data.secondWindowValue * 24): undefined;
                }
                else if(value == 'DAY')
                {
                    data.visitTypeWindow = data.visitTypeWindow ? Math.floor(data.visitTypeWindow / (data.visitTypeWindowDateType == 'HOUR' ? 24 : data.visitTypeWindowDateType == 'WEEK' ? 24 *7 : data.visitTypeWindowDateType == 'MONTH' ? 24 * 30 : 1)) : undefined;
                    data.firstWindowValue = data.firstWindowValue ? Math.floor(data.firstWindowValue / 24) :undefined;
                    data.secondWindowValue = data.secondWindowValue ? Math.floor(data.secondWindowValue / 24) :undefined;
                }
                data.visitTypeWindowDateType = value == 'HOUR' ? 'HOUR' : 'DAY';
                break;
            }
            default: {
                data[key] = value;
                break;
            }
        }
        this.setState({
            data,
        }, () => {
            if (key === 'visitCategory' && value) {
                this.queryType(value);  // 访视类别联动查询访视类型
            }
            if (key === 'visitingTypeId' && value) {
                this.querySingleVisitHourForAddVisit(value);
            }
        });
    }

    visitCountSelectChange = value => {
        const { data } = this.state;
        if (value == undefined) {
            data.visitTypeName = undefined;
        } else {
            data.visitTypeName = value.key;
        }
        this.setState({ data });
    }

    parseVisitCountData = (res, value) => {
        if (res.visitingFrequencyList) {
            const data = (res.visitingFrequencyList || []).map(item => ({
                text: item.configValue,
                value: item.configValue,
            }));
            this.setState({ visitCountOption: data });
        } else {
            this.setState({ visitCountOption: [] });
        }
    }

    visitCommentSelectChange = value => {
        const { data } = this.state;
        if (value == undefined) {
            data.visitComment = undefined;
        } else {
            data.visitComment = value.key;
        }
        this.setState({ data });
    }

    parsevisitCommentData = (res, value) => {
        if (res.list) {
            const data = (res.list || []).map(item => ({
                text: item.configureValue,
                value: item.configureValue,
            }));
            this.setState({ visitCommentOption: data });
        } else {
            this.setState({ visitCommentOption: [] });
        }
    }

    submit = () => {
        const { visitGroupingId } = this.props;
        const { data } = this.state;
        const { blindType } = sessionStorage;
        const isUnBlind = blindType === 'NOTBLIND';
        const {
            firstWindowSymbol, firstWindowValue,
            secondWindowSymbol, secondWindowValue, ...rest
        } = data;
        if (!rest.visitStageId) {
            return message.warning('阶段名称不能为空!');
        }
        if (!rest.visitCategory) {
            return message.warning('访视类别不能为空!');
        }
        if (!rest.visitingTypeId) {
            return message.warning('访视类型不能为空!');
        }
        if (!rest.singleVisitHour) {
            return message.warning('单访视工时不能为空!');
        }
        if (!rest.visitTypeName) {
            return message.warning('访视次数不能为空!');
        }
        if (!rest.visitTypeTimeUnit) {
            return message.warning('访视时间维度不能为空!');
        }
        if (!rest.referenceVisitTypeId && !isUnBlind && (hasValue(rest.visitTypeWindow) || hasValue(firstWindowValue))) {
            return message.warning('请选择对照基准');
        } else if (rest.referenceVisitTypeId && !isUnBlind && !(hasValue(rest.visitTypeWindow) || hasValue(firstWindowValue))) {
            return message.warning('请填写访视时间点或访视窗口');
        }
        if (
            (hasValue(firstWindowValue) && !hasValue(secondWindowValue)) ||
            (!hasValue(firstWindowValue) && hasValue(secondWindowValue))
        ) {
            return message.warning('访视窗口必须成对填写，请填写上边界或下边界的值，可以填写0');
        }
        if (firstWindowValue || firstWindowValue === 0) {
            rest.visitTypeWindowFloor = Number(SymbolType[firstWindowSymbol] + firstWindowValue);
            rest.visitTypeWindowCeil = Number(SymbolType[secondWindowSymbol] + secondWindowValue);
            if (rest.visitTypeWindowFloor > rest.visitTypeWindowCeil) {
                return message.warning('访视窗口的第一项值不能大于第二项值');
            }
        }

        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: this.config.url,
            data: {
                ...rest,
                visitGroupingId
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.hide();
                this.setState({ loading: false }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        });
    }

    render() {
        const { visitGroupingId, isBoundBlind } = this.props;
        const { visible, loading, stageList, categoryList, visitingTypeList, visitTypeList, compareBasicList, data, visitCountOption, visitCommentOption } = this.state;
        const { visitStageId, visitTypeName } = data;
        const { visitPeriodList: periodList } = getMatchOption(stageList, 'visitStageId', visitStageId);

        // 所选访视类型需要对照基准（接口返回 visitTypeReference 有值且等于 1）时，对照基准、访视时间点显示必填标记
        const [matchedVisitingType] = (visitingTypeList || []).filter(el => el.visitingTypeId == data.visitingTypeId);
        const needReference = !!matchedVisitingType && hasValue(matchedVisitingType.visitTypeReference) && matchedVisitingType.visitTypeReference == 1;

        const stageOption = stageList.map(item => <Option key={item.visitStageId} title={item.stageValue}>{item.stageValue}</Option>);
        const periodOption = (periodList || []).map(item => <Option key={item.visitPeriodId} title={item.periodValue}>{item.periodValue}</Option>)
        const categoryOption = categoryList.map(item => (
            <Option key={item.visitCategory} title={item.visitCategory}>
                <Tooltip placement="right" title={item.visitCategory}>
                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{item.visitCategory}</span>
                </Tooltip>
            </Option>
        ));
        const visitingTypeOption = visitingTypeList.map(item => (
            <Option key={item.visitingTypeId} title={item.visitingTypeName}>
                <Tooltip placement="right" title={item.visitingTypeName}>
                    <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden' }}>{item.visitingTypeName}</span>
                </Tooltip>
            </Option>
        ));
        const visitTypeOption = visitTypeList.map(item => <Option key={item.visitTypeId}>{item.visitTypeName}</Option>);
        const compareBasicOption = compareBasicList.map(item => <Option key={item.visitTypeId}>{item.visitTypeName}</Option>);
        return (
            <Modal
                title={this.config.title}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="500px"
            >
                <Spin spinning={loading}>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视阶段</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.visitStageId)}
                                onChange={value => this.handleChange(value, 'visitStageId')}
                            >
                                { stageOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text colon={true}>访视周期</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.visitPeriodId)}
                                onChange={value => this.handleChange(value, 'visitPeriodId')}
                            >
                                { periodOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视类别</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear={true}
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.visitCategory)}
                                onChange={value => this.handleChange(value, 'visitCategory')}
                            >
                                { categoryOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视类型</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.visitingTypeId)}
                                onChange={value => this.handleChange(value, 'visitingTypeId')}
                            >
                                {visitingTypeOption}
                                {
                                    // 历史数据无访视类别时，访视类型列表查不到选项，Select 会把 ID 原样显示，
                                    // 用行数据带回的访视类型名称补一个回退选项；切换访视类别后 visitingTypeId 被清空，回退选项自然消失
                                    !matchedVisitingType && data.visitingTypeId != null && data.visitingTypeShow &&
                                    <Option key={data.visitingTypeId} title={data.visitingTypeShow}>{data.visitingTypeShow}</Option>
                                }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>单访视工时 </Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <InputNumber
                                precision={2}
                                placeholder="请输入"
                                style={{ width }}
                                value={data.singleVisitHour}
                                onChange={value => this.handleChange(value, 'singleVisitHour')}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视次数</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {
                                visible &&
                                <SearchInput
                                    isEdit={this.config.edit}
                                    style={{ width }}
                                    params={{ limit: 20, visitGroupingId }}
                                    url={API_URL.plan.queryNotUsedVisitName}
                                    initValue={{ key: visitTypeName, label: visitTypeName }}
                                    keyword='configValue'
                                    dataSource={visitCountOption}
                                    parseData={this.parseVisitCountData}
                                    handleSelect={this.visitCountSelectChange}
                                    placeholder='输入名称检索'
                                />
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={false} colon={true}>访视备注</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            {
                                visible &&
                                <SearchInput
                                    isEdit={true}
                                    style={{ width }}
                                    params={{ type: 'VISIT_COMMENT' }}
                                    url={API_URL.evaluate.queryConfigWithChildByType}
                                    initValue={{ key: data.visitComment, label: data.visitComment }}
                                    keyword='configValue'
                                    filterOption={true}
                                    dataSource={visitCommentOption}
                                    parseData={this.parsevisitCommentData}
                                    handleSelect={this.visitCommentSelectChange}
                                    placeholder='输入名称检索'
                                />
                            }
                        </Col>
                    </Row>
                    {
                        isBoundBlind &&
                        <Row>
                            <Col span={8} style={{ textAlign: 'right' }}>
                                <Text colon={true}>关联对应盲态项目访视次数</Text>
                            </Col>
                            <Col span={15} offset={1}>
                                <Select
                                    allowClear
                                    placeholder="请选择"
                                    style={{ width }}
                                    value={toString(data.relatedId)}
                                    onChange={value => this.handleChange(value, 'relatedId')}
                                >
                                    {visitTypeOption}
                                </Select>
                            </Col>
                        </Row>
                    }
                     <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={true} colon={true}>访视时间维度</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                style={{ width }}
                                value={data.visitTypeTimeUnit}
                                onChange={value => this.handleChange(value, 'visitTypeTimeUnit')}
                            >
                                { VisitTypeTimeUnitOption }
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={needReference} colon={true}>对照基准</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <Select
                                allowClear
                                placeholder="请选择"
                                style={{ width }}
                                value={toString(data.referenceVisitTypeId)}
                                onChange={value => this.handleChange(value, 'referenceVisitTypeId')}
                            >
                                {compareBasicOption}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text asterisk={needReference} colon={true}>访视时间点</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <InputNumber
                                precision={0}
                                placeholder="请输入"
                                style={{ width: 135 }}
                                value={data.visitTypeWindow}
                                onChange={value => this.handleChange(value, 'visitTypeWindow')}
                            />
                            <Select
                                style={{ marginLeft: 10, width: 55 }}
                                value={data.visitTypeWindowDateType}
                                onChange={value => this.handleChange(value, 'visitTypeWindowDateType')}
                            >
                                { data.visitTypeTimeUnit == 'DAY' ? DateTypeOption : HourTypeOption}
                            </Select>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Text colon={true}>访视窗口</Text>
                        </Col>
                        <Col span={15} offset={1}>
                            <VisitWindow
                                data={data}
                                valueProp="firstWindowValue"
                                symbolProp="firstWindowSymbol"
                                onChange={this.handleChange}
                               // {{...DateType, ...HourType}[data.visitTypeWindowDateType]}
                                unit={data.visitTypeTimeUnit == 'HOUR' ? '小时':'天'}
                            />
                            <VisitWindow
                                data={data}
                                style={{marginTop: 10}}
                                valueProp="secondWindowValue"
                                symbolProp="secondWindowSymbol"
                                onChange={this.handleChange}
                                // unit={{...DateType, ...HourType}[data.visitTypeWindowDateType]}
                                unit={data.visitTypeTimeUnit == 'HOUR' ? '小时':'天'}
                            />
                        </Col>
                    </Row>
                </Spin>
            </Modal>
        );
    }
}

export default Update;



// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/Update.js